import React from 'react';
import "./i18nextConf";
import ReactDOM from 'react-dom/client';
import App from "./routes/App.jsx";

// Service Worker
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// Report Web Vitals
import reportWebVitals from './reportWebVitals';
// Import Google Analytics
import ReactGA from "react-ga4";
const TRACKING_ID = "G-X3DY82NWV8"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode> 
    <App />
  </React.StrictMode>
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

